import BaseOption from "%/dynamic-component-editor/classes/base-option";
import OptionExpression from "@bloglovin/inspire-engine/Helpers/OptionExpression.js";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import ProgressBarRange, { DEFAULT_RANGE_END } from "%/dynamic-component-editor/standard-elements/progress-bar/ProgressBarRange";

export default class ProgressBarMaximum extends BaseOption {

  // -------------------//
  // Static Class Vars //
  // -------------------//

  static userInterfaceComponent = {
    label: "Range end",
    component: inspectorTools.SIMPLE_INPUT,
    useVerticalOrientation: false,
    props: {
      inputType: "number",
    },
  };

  static defaultValue = DEFAULT_RANGE_END;

  static bindableDataType = "float";

  static expressionEditable = true;

  // -----------------------//
  // Public Static Methods //
  // -----------------------//

  static convertConfigValueToCompiledValue(configValue) {
    if (OptionExpression.isToken(configValue)) {
      return configValue;
    }
    return ProgressBarRange.toNumber(configValue, DEFAULT_RANGE_END);
  }
}
